import {Injectable} from '@angular/core';
import {DataService} from "../../../../services/external-api/data.service";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {Observable, of} from "rxjs";
import {emptyMmlList, emptyMmlListServiceResponse, emptyMmlMerchandiserStore, IMmlList, IMmlListServiceBody, IMmlMerchandiserStore} from "@retail-data-factory/rdf-angular-types-api";
import {catchError, map} from "rxjs/operators";
import * as moment from "moment";
import {emptyParty} from "@retail-data-factory/rdf-angular-types-api";
import {emptyCatalogItem} from "@retail-data-factory/rdf-angular-types-api";
import {Presenter} from "../../../internal/presenter/presenter";

@Injectable({
  providedIn: 'root'
})
export class ApiMmlService {

  constructor(
    private dataService: DataService,
    private configurationManager: ConfigurationManager,
    private presenter: Presenter
    ) {
  }


  getMmmLists(): Observable<Array<IMmlList>> {

    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/mmlists`, {}).pipe(
      map(value => {
          const result: Array<IMmlList> = [];
          if (value && value['report']) {

            value['report'].forEach(item => {
              const mmlList: IMmlList = this.mapMmlList(item);
              result.push(mmlList);
            });
          }
          return result;
        },
        catchError(error => {
          console.log(error);
          return of([]);
        }))
    );

  }

  getMmlList(mmlCode: string): Observable<IMmlList> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/mmlists/${mmlCode}`, {}).pipe(
      map(value => {
          let result: IMmlList = {
            ...emptyMmlList
          };
          if (value && value['report'] && value['report'].length > 0) {
            const item = value['report'][0];
            result = this.mapMmlList(item);
          }
          return result;
        },
        catchError(error => {
          console.log(error);
          return of({...emptyMmlList});
        }))
    );
  }

  private createMmlList(body: IMmlListServiceBody): Observable<any> {
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/mmlists`, {}, body);

  }

  private updateMmlList(mmlCode: string, body: IMmlListServiceBody): Observable<any> {
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/mmlists/${mmlCode}`, {}, body);

  }

  saveMmlList(mmlList: IMmlList): Observable<any> {
    const body: IMmlListServiceBody = this.prepareMmlBody(mmlList);
    if (mmlList.id) {
      return this.updateMmlList(mmlList.id, body);
    } else {
      return this.createMmlList(body);
    }
  }

  deleteMmlList(mmlCode: string) {

  }


  getMerchandiserByMml(mmlCode: string, showOnlyMerch: boolean = false): Observable<Array<IMmlMerchandiserStore>> {
    const queryParam = showOnlyMerch?'?show=merch':'';
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/mmlists/${mmlCode}/merch${queryParam}`, {}).pipe(
      map(value => {
          const list:Array<IMmlMerchandiserStore> = value.report.map(item => ({
            ...emptyMmlMerchandiserStore,
            merchPartyId: item['me_id_prty']!==null && item['me_id_prty']!==undefined?item['me_id_prty'].toString():'',
            merchPartyName: this.presenter.getPartnerById(item['me_id_prty']!==null && item['me_id_prty']!==undefined?item['me_id_prty'].toString():'').name,
            merchId: item['me_src_id_merch']?item['me_src_id_merch'].toString():'',
            merchCode: item['me_cd_grp']?item['me_cd_grp']:'',
            merchName: item['me_nm_grp']?item['me_nm_grp']:'',
            merchMdmId: item['me_id_grp']!==null && item['me_id_grp']!==undefined?item['me_id_grp'].toString():'',

            storePartyId: item['ste_id_prty']!==null && item['ste_id_prty']!==undefined?item['ste_id_prty'].toString():'',
            storeCode: item['ste_cd_grp']?item['ste_cd_grp']:'',
            storeName: item['ste_nm_grp']?item['ste_nm_grp']:'',
            storeMdmId: item['ste_id_grp']!==null && item['ste_id_grp']!==undefined?item['ste_id_grp'].toString():''
          }));

          return list;
        }
      )
    );
  }

  mapMmlList(item): IMmlList {
    const result: IMmlList = {
      ...emptyMmlList,
      id: item['id_mml'].toString(),
      name: item['nm_mml'],
      statusCode: item['mml_status_code'],
      creationDate: item['dt_mml_create'] ? moment(item['dt_mml_create'], 'YYYYMMDD').toDate() : null,
      profile: item['profile'],
      assign: [],
      fromDate: item['dt_ef'] ? moment(item['dt_ef'], 'YYYYMMDD').toDate() : null,
      toDate: item['dt_ep'] ? moment(item['dt_ep'], 'YYYYMMDD').toDate() : null,
//      fromDate: moment(item['dt_ef']?item['dt_ef']:'20000101', 'YYYYMMDD').toDate(),
//      toDate: moment(item['dt_ep']?item['dt_ep']:'29991231', 'YYYYMMDD').toDate(),
      party: item['parties'].map(t => ({
        ...emptyParty,
        id: t['id_prty'].toString()
      })),
      items: item['items'].map(t => ({
        ...emptyCatalogItem,
        id: t['id_itm'].toString(),
        quantity: t['qu_itm'] ? t['qu_itm'] : 0,
        name: t['nm_itm'],
        code: t['cd_itm'],
        bonusAmount: t['bonus_amount'] ? t['bonus_amount'] : 0,
        needPhoto: t['need_photo'] === 1
      }))
    };
    if (item['profile'] && item['profile']['assign']) {
      result.assign = item['profile']['assign'].map(t => ({
        mdmTypeCode: t['mdm_type_code'],
        mdmLevelNum: t['mdm_level_num'],
        items: t['items'].map(i => ({code: i.code, name: i.name}))
      }));
    }

    return result;
  }

  prepareMmlBody(mmlList: IMmlList): IMmlListServiceBody {
    const result: IMmlListServiceBody = {
      ...emptyMmlListServiceResponse,
      nm_mml: mmlList.name,
      mml_status_code: mmlList.assign.length > 0 ? 'ACTIVE' : 'DRAFT',
      dt_ef: moment(mmlList.fromDate).format('YYYYMMDD'),
      dt_ep: moment(mmlList.toDate).format('YYYYMMDD'),
      profile: {
        ...mmlList.profile
      },
      items: mmlList.items.map(t => ({id: t.id, quantity: t.quantity, bonus_amount: t.bonusAmount, need_photo: t.needPhoto ? 1 : 0})),
      parties: mmlList.party.map(t => t.id)
    };
    result.profile['assign'] = [];
    result.profile['assign'] = mmlList.assign.map(t => ({
      mdm_type_code: t.mdmTypeCode,
      mdm_level_num: t.mdmLevelNum,
      items: t.items.map(k => ({code: k.code, name: k.name}))
    }));
    return result;
  }


  decodeMmlStatusCode(mmlList: IMmlList): string {
    if (mmlList.assign.length === 0) {
      return 'Не назначен';
    }
    if (!mmlList.toDate || !mmlList.fromDate) {
      return 'Не указан период';
    }

    if (moment().isBefore(moment(mmlList.fromDate), 'day')) {
      return 'Неактивный';
    }
    if (moment().isAfter(moment(mmlList.toDate), 'day')) {
      return 'Неактивный';
    }

    return 'Активный';
  }

  decodeMmlStatusCodeColor(mmlList: IMmlList): string {
    if (mmlList.assign.length === 0) {
      return '#ff0000';
    }
    if (!mmlList.toDate || !mmlList.fromDate) {
      return '#ff0000';
    }

    if (moment().isBefore(moment(mmlList.fromDate), 'day')) {
      return '#3a90c7';
    }
    if (moment().isAfter(moment(mmlList.toDate), 'day')) {
      return '#3a90c7';
    }

    return '#00a651';


    if (!mmlList.toDate || !mmlList.fromDate) {
      return '#ff0000';
    }
    if (moment().isBefore(moment(mmlList.fromDate), 'day')) {
      return '#ff0000';
    }
    if (moment().isAfter(moment(mmlList.toDate), 'day')) {
      return '#ff0000';
    }

    switch (mmlList.statusCode) {
      case 'DRAFT':
        return '#bfc0c2';
      case 'ACTIVE':
        return '#3a90c7';
      default:
        return '#bfc0c2';
    }
  }
}
